import { getYMDandHour } from "./formatters";

export const SessionService = () => {};

SessionService.snapshot = {
    state: "check_external_params_start",
    nome: "",
    cognome: "",
    email: "",
    cellulare: "",
    codiceFiscale: "",
    progress: 0,
    ricontatto: false,
    filiali: [],
    disponibilita: [],
    orari: [],
    filialeScelta: null,
    filialeSceltaIdx: 0,
    dataScelta: null,
    orarioScelto: null,
    utenteRiconosciuto: false,
    prodotto: "prestito",
    impiego: -1,
    consolidamento: -1,
    utm_term: "Nuovo fissa appuntamento",
    oppID: "",
    capResidenza: "",
    solo_info: "no",
    click_clink: "no",
    comuneResidenza: "",
    indirizzoResidenza: "",
    tipoAzienda: "",
    iscrittoCameraCommercio: "",
};

SessionService.getAppointmentPayload = () => {
    const payload = {};

    // prettier-ignore
    const availableFields = [
    "nome", 
    "cognome", 
    "email", 
    "cellulare", 
    "codiceFiscale", 
    "cap_utente",
    // "privacyExtcommoffer", 
    // "privacyOtherservice", 
    // "privacyProfilazione", 
    "privacyInterncommoffer", 
    "impiego", 
    "consolidamento", 
    "prodotto", 
    "ricontatto", 
    "oppID", 
    "capResidenza", 
    "IsForzosoClink",
    "comuneResidenza",
    "indirizzoResidenza",
    "tipoAzienda",
    "iscrittoCameraCommercio",
    "tipoOccupazione"
  ];
    availableFields.forEach((field) => {
        if ("ricontatto" == field && SessionService.get("ricontatto_external")) {
            payload[field] = SessionService.get("ricontatto_external") == "1" ? true : false;
        } else if ("ricontatto" == field && SessionService.get("ricontattoLuogo") == true && SessionService.get("ricontattoCf") == true) {
            payload[field] = true;
        }

        if (!SessionService.get(field)) {
            return;
        }
        let fieldValue = SessionService.get(field);
        // if (["privacyExtcommoffer", "privacyOtherservice", "privacyProfilazione", "privacyInterncommoffer", "iscrittoCameraCommercio"].includes(field)) {
        if (["privacyInterncommoffer", "iscrittoCameraCommercio"].includes(field)) {
            fieldValue = parseInt(fieldValue);
        }
        payload[field] = fieldValue;
    });

    // prettier-ignore
    const trackingFields = ["utm_term", "utm_source", "utm_medium", "utm_campaign", "utm_date", "utm_content", "prodotto"];
    trackingFields.forEach((field) => {
        payload[field] = SessionService.get(field) || window.printParam(field);
    });

    payload["mediacode"] = localStorage.getItem("newmediacode") || SessionService.get("mediacode") || "";

    let mediaHistory = localStorage.getItem("media_history") || "";
    payload["utmHistory"] = mediaHistory;
    payload["utm_history"] = mediaHistory;

    if (SessionService.get("filialeScelta")) {
        payload["filiale"] = SessionService.get("filialeScelta").codFiliale || SessionService.get("filialeScelta").CodiceOcsPV;
    }
    // if (SessionService.get("dataScelta") && SessionService.get("orarioScelto")) {
    //     payload["data"] = getYMDandHour(SessionService.get("dataScelta").data, SessionService.get("orarioScelto"));
    // }
    if (SessionService.get("dataScelta")) {
        payload["data"] = SessionService.get("dataScelta").data;
    }

    return payload;
};

SessionService.listeners = new Set();

SessionService.subscribe = (listener) => {
    SessionService.listeners.add(listener);
    return () => SessionService.listeners.delete(listener);
};

SessionService.notify = () => {
    SessionService.listeners.forEach((listener) => listener());
};

SessionService.set = (key, value) => {
    SessionService.snapshot[key] = value;
    SessionService.notify();
};

SessionService.merge = (object) => {
    SessionService.snapshot = { ...SessionService.snapshot, ...object };
    SessionService.notify();
};

SessionService.get = (key) => {
    if (!key) return SessionService.snapshot;
    return SessionService.snapshot[key];
};
